<div class="cd-page">
  <app-counselor-nav></app-counselor-nav>
  <app-messages-thread-page></app-messages-thread-page>
</div>
